import { defineStore } from 'pinia'
import { useSwal } from '@/composables'
import {
  destroyGame,
  fetchUserGames,
  gameIndex,
  replicateGame,
  storeGame,
} from '@/api/gameApi'
import { extractClapError } from '@/helpers/errorHelper'

type State = {
  count: number

  allGames: Game[]
  allGamesFiltered: Game[]
}

export const useAllGamesStore = defineStore('games', {
  state: (): State => ({
    count: 0,

    allGames: [],
    allGamesFiltered: [],
  }),

  getters: {
    games: state => state.allGames,

    gameFiltered: state => state.allGamesFiltered,
    gamesCount: state => state.count,
  },

  actions: {
    setGames(payload: Game[]) {
      this.allGames = payload
      this.allGamesFiltered = [...payload]
    },

    filterGames({ key, val }: { key: keyof Game; val: any }) {
      this.allGamesFiltered = !val
        ? [...this.games]
        : this.games.filter(f => f[key] === val)
    },
    destroyGame(id: string) {
      this.allGames = this.games.filter(game => game._id !== id)
    },
    storeGame(payload: any) {
      this.count++
      if (isFinite(+payload.setIndex)) {
        const setIndex = payload.setIndex
        delete payload.setIndex
        this.games.splice(setIndex, 0, payload)
        if (this.games.length > 5) this.games.pop()
        return
      }
      this.games.push(payload)
    },
    clearGames() {
      this.allGames = []
    },
    setCount(payload: number) {
      this.count = payload
    },

    updateGame(updatedGame: Game) {
      const index = this.games.findIndex(g => g._id === updatedGame._id)
      if (index !== -1) {
        this.games.splice(index, 1, updatedGame)
      }
    },

    // addNumOfShares({ gameId, numOfShares }: any) {
    //   const game = this.games.find(g => g._id === gameId)
    //   if (game) game.numOfShares = numOfShares
    // },

    async indexGames(
      params = {
        page: 1,
        perPage: 25,
        search: '',
        sortBy: '',
        sortDesc: false,
        user: '',
      }
    ) {
      try {
        const { count, games } = await gameIndex(params)
        this.setCount(count)
        this.setGames(games)
        return games
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
        console.log(e)
      }
    },

    async getMyGames() {
      try {
        const { games } = await fetchUserGames()
        this.setGames(games)
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
      }
    },

    async storeGameRemote(payload: any) {
      try {
        const game = await storeGame(payload)
        this.storeGame(game)
        this.setGames(game)
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
      }
    },

    async destroyGameRemote(id: string) {
      try {
        await destroyGame(id)
        this.destroyGame(id)
        this.setGames(this.games.filter(g => g._id !== id))
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
      }
    },

    async replicateGame(id: string) {
      try {
        const game = await replicateGame(id)
        const index = this.games.findIndex(g => g._id === id)
        this.storeGame({ ...game, setIndex: index })
      } catch (e) {
        console.error(e)

        useSwal().timeoutSwal({
          icon: 'error',
          title: extractClapError(e as ClapError),
        })
      }
    },
  },
})
